export const getForcedParticipationsFromUrl = (windowHash) => {
    if (windowHash.startsWith('#ab')) {
        const tokens = windowHash.replace('#ab-', '').split(',');
        return tokens.reduce((obj, token) => {
            const [testId, variantId] = token.split('=');
            if (testId && variantId) {
                return {
                    ...obj,
                    [testId]: { variant: variantId },
                };
            }
            return obj;
        }, {});
    }
    return {};
};
